import moment from 'moment'
import {LeadByID} from '../leadTypes'

interface LeadSummaryPanelProps {
  lead: LeadByID
  title?: string
}

const formatName = (firstName?: string | null, lastName?: string | null) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ')
  return fullName.length > 0 ? fullName : 'N/R'
}

export const LeadSummaryPanel: React.FC<LeadSummaryPanelProps> = ({
  lead,
  title = 'Lead Summary',
}) => {
  const assignedTo =
    lead.user?.edges?.length > 0
      ? lead.user.edges.map(({node}) => `${node.firstName} ${node.lastName}`).join(', ')
      : 'N/R'
  const tags =
    lead.tagInsurance?.edges?.length > 0
      ? lead.tagInsurance.edges.map(({node}) => node.name).join(', ')
      : 'N/R'
  const createdAt = lead.created ? moment(lead.created).format('DD MMM YYYY, hh:mm A') : 'N/R'
  const lastUpdate = lead.updated ? moment(lead.updated).format('DD MMM YYYY, hh:mm A') : 'N/R'
  const addressLine =
    lead.personalLead?.streetAddress || lead.comercialLead?.contactLastname || 'N/R'
  const city = lead.personalLead?.city || 'N/R'
  const state = lead.personalLead?.state || 'N/R'
  const postalCode = lead.personalLead?.postalCode || 'N/R'
  const birthDay = lead.personalLead?.birthDay
    ? moment(lead.personalLead.birthDay).format('DD MMM, YY')
    : 'N/R'

  return (
    <div>
      <div className='kt-heading kt-heading--sm custom-border-brand my-3'>{title}</div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Pipeline:</span>
        <span className='kt-widget__data'>{lead.stagePipeline?.pipeline?.name || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Stage:</span>
        <span className='kt-widget__data'>{lead.stagePipeline?.name || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Source:</span>
        <span className='kt-widget__data'>{lead.leadSource?.name || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Tags:</span>
        <span className='kt-widget__data'>{tags}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Reason for Loss:</span>
        <span className='kt-widget__data'>{lead.reasonLeadLoss?.reason || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Assigned to:</span>
        <span className='kt-widget__data'>{assignedTo}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Created at:</span>
        <span className='kt-widget__data'>{createdAt}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Last update:</span>
        <span className='kt-widget__data'>{lastUpdate}</span>
      </div>
      <div className='kt-heading kt-heading--sm custom-border-brand my-3'>Personal Information</div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Name:</span>
        <span className='kt-widget__data'>{lead.name || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Email:</span>
        <span className='kt-widget__data'>{lead.email || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Phone:</span>
        <span className='kt-widget__data'>{lead.phone || 'N/R'}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Date of Birth:</span>
        <span className='kt-widget__data'>{birthDay}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Address:</span>
        <span className='kt-widget__data'>{addressLine}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>City:</span>
        <span className='kt-widget__data'>{city}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>State:</span>
        <span className='kt-widget__data'>{state}</span>
      </div>
      <div className='kt-widget__info'>
        <span className='kt-widget__label'>Zip Code:</span>
        <span className='kt-widget__data'>{postalCode}</span>
      </div>
    </div>
  )
}
